<template>
  <q-radio dense :disable="disableComputed || readonlyComputed">
    <template v-for="(slot, name) in $slots" v-slot:[name]="scope">
      <slot :name="name" v-bind="scope ?? {}" />
    </template>
  </q-radio>
</template>

<script setup>
import { useFieldsetState } from "@/composables/useFieldsetState.js"

const props = defineProps({
  disable: Boolean,
  readonly: Boolean
})

const { disableComputed, readonlyComputed } = useFieldsetState(props)
</script>
